export default "__VITE_ASSET__CwnrvQbQ__"